export default {
  title: {
    id: 'bo_seller_customer_reviews_title',
    defaultMessage: 'Ratings and reviews',
  },
  loading: {
    id: 'bo_seller_customer_reviews_loading',
    defaultMessage: 'Loading your reviews',
  },

  reviewsCount: {
    id: 'bo_seller_customer_reviews_review_number',
    defaultMessage: `{count, plural,
            =0 {No review}
            one {# review}
            other {# reviews}
    }`,
  },
}
